import React from "react";
import neverLandUtils from "../../utils/NeverLandUtils";
import dayjs from "dayjs";


const RecordDataTable = ({tableData, homeTeamName, awayTeamName}) => {

  const formatDate = (dateString) => {
    const regex = /^\d{2}-\d{2}-\d{2}$/;

    if (regex.test(dateString)) {
      // 이미 YY-MM-DD 형식이면 YY.MM.DD 형식으로 변환
      return dateString.replace(/-/g, ".");
    }

    const date = dayjs(dateString);
    return date.format("YY.MM.DD");
  };

  return (
      <table className="max-h-[23rem] overflow-y-scroll border-separate border-spacing-0 w-full text-sm">
        <tbody>
        {tableData?.map((data, index) => {
          return (
              <React.Fragment key={index}>
                <tr className="text-center ring-1 ring-gray-300 rounded-lg shadow-md">
                  {/* <- 날짜 -> */}
                  <td className="rounded-l-lg bg-white w-1/4">{formatDate(data.date)}</td>
                  {/* <- 홈팀이름 -> */}
                  <td className={neverLandUtils.classNames(data.homeTeam === homeTeamName ? "bg-red-600 text-white" : data.homeTeam === awayTeamName ? "bg-blue-600 text-white" : "bg-white w-1/4 whitespace-nowrap")}>
                    {neverLandUtils.trimTeamName(data.homeTeam)}
                  </td>
                  {/* <- 점수 -> */}
                  <td className="bg-white w-1/4">
                      <span className={data.homeScore > data.awayScore ? 'text-red-600' : 'black'}>
                        {data.homeScore}
                      </span>
                    {" : "}
                    <span className={data.homeScore < data.awayScore ? 'text-red-600' : 'black'}>
                        {data.awayScore}
                      </span>
                  </td>
                  {/* <- 원정팀 이름 -> */}
                  <td className={neverLandUtils.classNames(data.awayTeam === homeTeamName ? "bg-red-600 text-white" : data.awayTeam === awayTeamName ? "bg-blue-600 text-white" : "bg-white", "rounded-r-lg w-1/4 whitespace-nowrap")}>
                    {neverLandUtils.trimTeamName(data.awayTeam)}
                  </td>
                </tr>

                <tr className="h-1"></tr>

                <tr className="text-center">
                  {/* <- 리그 -> */}
                  <td>{data.game.league}</td>
                  {/* <- 배당 -> */}
                  <td>
                    {data.game.win !== "0.00" && data.game.win !== "-" && data.game.win !== "0" && (
                        <span
                            className={neverLandUtils.classNames(
                                data.homeScore > data.awayScore ? "bg-yellow-300" : "bg-gray-200", "rounded-lg px-2 my-3"
                            )}
                        >
                      {data.game.win.replace(/[↑↓]/g, '')}
                      </span>
                    )}
                  </td>
                  <td>
                    {data.game.draw !== "0.00" && data.game.draw !== "-" && data.game.draw !== "0" && (
                        <span
                            className={neverLandUtils.classNames(
                                data.homeScore === data.awayScore ? "bg-yellow-300" : "bg-gray-200", "rounded-lg px-2"
                            )}
                        >
                      {data.game.draw.replace(/[↑↓]/g, '')}
                      </span>
                    )}
                  </td>
                  <td>
                    {data.game.lose !== "0.00" && data.game.lose !== "-" && data.game.lose !== "0" && (
                        <span
                            className={neverLandUtils.classNames(
                                data.homeScore < data.awayScore ? "bg-yellow-300" : "bg-gray-200", "rounded-lg px-2"
                            )}
                        >
                      {data.game.lose.replace(/[↑↓]/g, '')}
                      </span>
                    )}
                  </td>
                </tr>
                <tr className="h-2"></tr>
              </React.Fragment>
          )
        })
        }
        </tbody>
      </table>
  )
}
export default RecordDataTable;